module.exports = __webpack_public_path__ + "static/img/icon-enn-item2.bdc9264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enn-item2.png
// module id = YUeu
// module chunks = 21